import { ChevronRight } from "lucide-react";

const ActionCard = ({
  width = "full",
  icon,
  title,
  subtitle,
  handleClick = () => {},
}) => {
  return (
    <div
      onClick={handleClick}
      className={`w-${width} border-[0.5px] cursor-pointer p-[10px] h-[70px] flex items-center justify-between border-[#C0C3C2] rounded-[5px] bg-white`}
    >
      <div className="w-[10%] flex items-center justify-center">
        <div className="h-[54px] p-[10px] w-[54px] shadow-[1px_1px_20px_0px_#0000000D] rounded-full flex items-center justify-center">
          {icon}
        </div>
      </div>
      <div className="w-[85%] flex flex-col">
        <p className="text-[#000000] font-medium text-[14px]">{title}</p>
        <p className="text-[#737373] font-normal text-[12px]">{subtitle}</p>
      </div>
      <div className="w-[5%] flex justify-end">
        <ChevronRight color="#000000" size={18} />
      </div>
    </div>
  );
};

export default ActionCard;
